import React from 'react';

const StatCard = ({ icon, value, label, tag, fillWidth, theme, delay }) => {
  const themeClasses = {
    green: 'sc-green',
    blue: 'sc-blue',
    amber: 'sc-amber',
    rose: 'sc-rose',
  };

  const blobColors = {
    green: '#22c55e',
    blue: '#3b82f6',
    amber: '#f59e0b',
    rose: '#f43f5e',
  };

  const iconColors = {
    green: '#bbf7d0',
    blue: '#bfdbfe',
    amber: '#fde68a',
    rose: '#fecdd3',
  };

  const tagStyles = {
    green: { background: '#bbf7d0', color: '#15803d' },
    blue: { background: '#bfdbfe', color: '#1d4ed8' },
    amber: { background: '#fde68a', color: '#92400e' },
    rose: { background: '#fecdd3', color: '#be123c' },
  };

  const valueColors = {
    green: '#15803d',
    blue: '#1d4ed8',
    amber: '#b45309',
    rose: '#be123c',
  };

  const fillGradients = {
    green: 'linear-gradient(90deg,#4ade80,#16a34a)',
    blue: 'linear-gradient(90deg,#93c5fd,#2563eb)',
    amber: 'linear-gradient(90deg,#fcd34d,#d97706)',
    rose: 'linear-gradient(90deg,#fda4af,#e11d48)',
  };

  return (
    <div
      className={`sc ${themeClasses[theme]}`}
      style={{ animationDelay: delay }}
    >
      <div className="sc-blob" style={{ background: blobColors[theme] }}></div>
      <div className="sc-row1">
        <div className="sc-icon" style={{ background: iconColors[theme] }}>{icon}</div>
        <div className="sc-tag" style={tagStyles[theme]}>{tag}</div>
      </div>
      <div className="sc-val" style={{ color: valueColors[theme] }}>{value}</div>
      <div className="sc-lbl" style={{ color: valueColors[theme] }}>{label}</div>
      <div className="sc-bar">
        <div className="sc-fill" style={{ width: fillWidth, background: fillGradients[theme] }}></div>
      </div>
    </div>
  );
};

export default StatCard;
